/**
 * hamper-builder.js - Make Your Own Combo
 * ---------------------------------------------------------------------------
 * RATE TO RATE pricing. Each pick is added to the cart as its own line at its
 * own price; the combo total is just the sum. There is no discounted pack
 * product involved any more.
 *
 * The pack rule still holds: Add to cart unlocks only on exactly 4, 6 or 8
 * items (whatever the section's pack sizes are set to).
 *
 * Where the customer lands afterwards is the section's "After adding the\n * combo" setting - checkout (default), the cart drawer, or the cart page.
 * We never clear the cart first: taking items the customer chose earlier out
 * from under them would be worse than showing a slightly bigger checkout.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.__hamperReady) return;
    root.__hamperReady = true;

    var sizes = (root.getAttribute('data-sizes') || '').split('~')
      .map(function (s) { return parseInt(s, 10); })
      .filter(function (n) { return n > 0; })
      .sort(function (a, b) { return a - b; });

    if (!sizes.length) return;

    var maxSize = parseInt(root.getAttribute('data-max'), 10) || sizes[sizes.length - 1];
    var freeShip = parseInt(root.getAttribute('data-free-shipping'), 10) || 0;
    var allowDupes = root.getAttribute('data-allow-duplicates') === 'true';
    var celebrate = root.getAttribute('data-celebrate') === 'true';
    var afterAdd = root.getAttribute('data-after-add') || 'checkout';
    var moneyFormat = root.getAttribute('data-money-format') || 'Rs. {{amount}}';

    var grid = root.querySelector('[data-grid]');
    var slots = root.querySelector('[data-slots]');
    var slotsLabel = root.querySelector('[data-slots-label]');
    var hint = root.querySelector('[data-hint]');
    var totalEl = root.querySelector('[data-total]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var clearBtn = root.querySelector('[data-clear]');
    var meterFill = root.querySelector('[data-meter-fill]');
    var shipFill = root.querySelector('[data-ship-fill]');
    var shipText = root.querySelector('[data-shipping]');
    var searchInput = root.querySelector('[data-search-input]');
    var noResults = root.querySelector('[data-no-results]');
    var panel = root.querySelector('[data-panel]');
    var errorBox = root.querySelector('[data-error]');
    var errorText = root.querySelector('[data-error-text]');
    var mobileCount = root.querySelector('[data-mobile-count]');
    var mobileTotal = root.querySelector('[data-mobile-total]');
    var mobileAdd = root.querySelector('[data-mobile-add]');
    var mobileFill = root.querySelector('[data-mobile-fill]');
    var summary = root.querySelector('[data-summary]');
    var jumpBtn = root.querySelector('[data-jump]');

    // variantId -> { qty, price, title, img }
    var picks = {};
    var lastHit = 0;

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('no_decimals') !== -1) amount = String(Math.round(cents / 100));
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      amount = parts.join('.');
      if (moneyFormat.indexOf('{{') !== -1) {
        return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
      }
      return 'Rs. ' + amount;
    }

    function count() {
      var n = 0;
      for (var id in picks) if (picks.hasOwnProperty(id)) n += picks[id].qty;
      return n;
    }

    function subtotal() {
      var t = 0;
      for (var id in picks) if (picks.hasOwnProperty(id)) t += picks[id].qty * picks[id].price;
      return t;
    }

    function currentPack(n) {
      for (var i = 0; i < sizes.length; i++) if (sizes[i] === n) return sizes[i];
      return null;
    }

    function nextPack(n) {
      for (var i = 0; i < sizes.length; i++) if (sizes[i] > n) return sizes[i];
      return null;
    }

    // ------------------------------------------------------- rendering ---

    function renderSlots(n) {
      var shown = Math.max(maxSize, n);
      var html = '';
      var flat = [];

      for (var id in picks) {
        if (!picks.hasOwnProperty(id)) continue;
        for (var q = 0; q < picks[id].qty; q++) flat.push({ id: id, item: picks[id] });
      }

      for (var i = 0; i < shown; i++) {
        var isMilestone = sizes.indexOf(i + 1) !== -1;
        var filled = flat[i];
        var cls = 'hamper-slot';
        if (isMilestone) cls += ' is-milestone';
        if (filled) cls += ' is-filled';
        if (isMilestone && n >= i + 1) cls += ' is-goal-hit';

        html += '<div class="' + cls + '">';
        if (filled) {
          html += filled.item.img
            ? '<img class="hamper-slot__img" src="' + filled.item.img + '" alt="">'
            : '<span class="hamper-slot__initials">' + filled.item.title.slice(0, 2).toUpperCase() + '</span>';
          html += '<button type="button" class="hamper-slot__remove" data-remove="' + filled.id + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>' +
            '</button>';
        } else {
          html += '<span class="hamper-slot__num">' + (i + 1) + '</span>';
        }
        html += '</div>';
      }
      slots.innerHTML = html;
    }

    function paintCards() {
      var actions = grid.querySelectorAll('[data-variant-id]');
      for (var i = 0; i < actions.length; i++) {
        var el = actions[i];
        var id = el.getAttribute('data-variant-id');
        var qty = picks[id] ? picks[id].qty : 0;
        var addButton = el.querySelector('[data-action="add"]');
        var stepper = el.querySelector('[data-stepper]');
        var countEl = el.querySelector('[data-count]');
        var card = el.closest('.hamper-card');

        if (!addButton || !stepper) continue;

        if (qty > 0) {
          addButton.hidden = true;
          stepper.hidden = false;
          if (countEl) countEl.textContent = String(qty);
          if (card) card.classList.add('is-selected');
          var inc = stepper.querySelector('[data-action="increase"]');
          if (inc) inc.disabled = !allowDupes;
        } else {
          addButton.hidden = false;
          stepper.hidden = true;
          if (card) card.classList.remove('is-selected');
        }
      }
    }

    function paint() {
      var n = count();
      var total = subtotal();
      var pack = currentPack(n);
      var next = nextPack(n);

      renderSlots(n);
      paintCards();

      totalEl.textContent = money(total);

      var pct = Math.min(100, (n / maxSize) * 100);
      if (meterFill) meterFill.style.width = pct + '%';
      var stops = root.querySelectorAll('.hamper-meter__stop');
      for (var i = 0; i < stops.length; i++) {
        var target = parseInt(stops[i].getAttribute('data-stop'), 10);
        stops[i].classList.toggle('is-reached', n >= target);
        stops[i].classList.toggle('is-current', next === target);
      }

      if (shipText) {
        if (freeShip > 0) {
          var shipPct = Math.min(100, (total / freeShip) * 100);
          if (shipFill) shipFill.style.width = shipPct + '%';
          if (total >= freeShip) {
            shipText.textContent = 'Free delivery unlocked';
            shipText.classList.add('is-won');
          } else {
            shipText.textContent = 'Add ' + money(freeShip - total) + ' more for free delivery';
            shipText.classList.remove('is-won');
          }
        } else {
          shipText.textContent = '';
        }
      }

      if (n === 0) {
        slotsLabel.textContent = 'Pick any ' + sizes.join(', ') + ' items';
        hint.textContent = 'Everything is charged at its normal price. Choose a pack of ' + sizes.join(', ') + ' to continue.';
        hint.classList.remove('is-ready');
      } else if (pack) {
        slotsLabel.textContent = 'Pack of ' + pack + ' - ready';
        hint.textContent = 'Your pack of ' + pack + ' is ready.';
        hint.classList.add('is-ready');
      } else {
        slotsLabel.textContent = n + (n === 1 ? ' item selected' : ' items selected');
        if (next) {
          hint.textContent = 'Add ' + (next - n) + ' more to complete a pack of ' + next + '.';
        } else {
          hint.textContent = 'Packs come in ' + sizes.join(', ') + '. Remove ' + (n - sizes[sizes.length - 1]) +
            ' to get back to ' + sizes[sizes.length - 1] + '.';
        }
        hint.classList.remove('is-ready');
      }

      var ready = !!pack;
      addBtn.disabled = !ready;
      if (mobileAdd) mobileAdd.disabled = !ready;
      if (addLabel && pack) {
        addLabel.textContent = (afterAdd === 'checkout' ? 'Checkout pack of ' : 'Add pack of ') + pack + ' - ' + money(total);
      }

      if (clearBtn) clearBtn.hidden = n === 0;

      if (mobileCount) mobileCount.textContent = n + (n === 1 ? ' item' : ' items');
      if (mobileTotal) mobileTotal.textContent = money(total);
      if (mobileFill) mobileFill.style.width = pct + '%';

      if (celebrate && pack && pack !== lastHit) {
        lastHit = pack;
        burst();
        if (panel) {
          panel.classList.add('is-celebrating');
          setTimeout(function () { panel.classList.remove('is-celebrating'); }, 700);
        }
      }
      if (!pack) lastHit = 0;
    }

    // ----------------------------------------------------- celebration ---

    function burst() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var canvas = document.createElement('canvas');
      canvas.className = 'hamper-confetti-canvas';
      document.body.appendChild(canvas);

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.scale(dpr, dpr);

      var colours = ['#D9A227', '#cc4147', '#F3C57F', '#1f7a3d', '#ffffff'];
      var bits = [];
      for (var i = 0; i < 90; i++) {
        bits.push({
          x: window.innerWidth / 2,
          y: window.innerHeight / 2,
          vx: (Math.random() - 0.5) * 14,
          vy: (Math.random() - 0.9) * 14,
          size: 4 + Math.random() * 6,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.3,
          colour: colours[Math.floor(Math.random() * colours.length)]
        });
      }

      var start = Date.now();
      (function frame() {
        var elapsed = Date.now() - start;
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        for (var i = 0; i < bits.length; i++) {
          var b = bits[i];
          b.vy += 0.35;
          b.x += b.vx;
          b.y += b.vy;
          b.rot += b.vr;
          ctx.save();
          ctx.translate(b.x, b.y);
          ctx.rotate(b.rot);
          ctx.globalAlpha = Math.max(0, 1 - elapsed / 1800);
          ctx.fillStyle = b.colour;
          ctx.fillRect(-b.size / 2, -b.size / 2, b.size, b.size * 0.6);
          ctx.restore();
        }
        if (elapsed < 1800) requestAnimationFrame(frame);
        else canvas.remove();
      })();
    }

    // ---------------------------------------------------------- events ---

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;

      var holder = btn.closest('[data-variant-id]');
      if (!holder) return;

      var id = holder.getAttribute('data-variant-id');
      var action = btn.getAttribute('data-action');

      if (action === 'add' || action === 'increase') {
        if (holder.getAttribute('data-available') !== 'true') return;
        if (picks[id] && !allowDupes) return;
        if (picks[id]) picks[id].qty += 1;
        else picks[id] = {
          qty: 1,
          price: parseInt(holder.getAttribute('data-price'), 10) || 0,
          title: holder.getAttribute('data-title') || '',
          img: holder.getAttribute('data-image-src') || ''
        };
      } else if (action === 'decrease') {
        if (!picks[id]) return;
        picks[id].qty -= 1;
        if (picks[id].qty <= 0) delete picks[id];
      }

      paint();
    });

    slots.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      var id = btn.getAttribute('data-remove');
      if (!picks[id]) return;
      picks[id].qty -= 1;
      if (picks[id].qty <= 0) delete picks[id];
      paint();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        picks = {};
        lastHit = 0;
        paint();
      });
    }

    var tabs = root.querySelectorAll('.hamper-tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].classList.remove('active');
          tabs[j].setAttribute('aria-selected', 'false');
        }
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        filter();
      });
    }

    if (searchInput) searchInput.addEventListener('input', filter);

    function filter() {
      var activeTab = root.querySelector('.hamper-tab.active');
      var cat = activeTab ? activeTab.getAttribute('data-tab') : '';
      var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var cards = grid.querySelectorAll('.hamper-card');
      var visible = 0;

      for (var i = 0; i < cards.length; i++) {
        var okCat = !cat || cards[i].getAttribute('data-category') === cat;
        var okQ = !q || (cards[i].getAttribute('data-search') || '').indexOf(q) !== -1;
        var show = okCat && okQ;
        cards[i].hidden = !show;
        if (show) visible++;
      }
      if (noResults) noResults.hidden = visible > 0;
    }

    if (jumpBtn && summary) {
      jumpBtn.addEventListener('click', function () {
        summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // ----------------------------------------------------- add to cart ---

    function showError(msg) {
      if (!errorBox || !errorText) return;
      errorText.textContent = msg;
      errorBox.hidden = false;
      setTimeout(function () { errorBox.hidden = true; }, 5000);
    }

    function submit() {
      var n = count();
      var pack = currentPack(n);
      if (!pack) return;

      var items = [];
      for (var id in picks) {
        if (!picks.hasOwnProperty(id)) continue;
        items.push({
          id: Number(id),
          quantity: picks[id].qty,
          properties: { 'Combo': 'Pack of ' + pack }
        });
      }

      addBtn.classList.add('loading');
      addBtn.disabled = true;
      if (mobileAdd) mobileAdd.disabled = true;

      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          addBtn.classList.remove('loading');

          if (!res.ok) {
            showError((res.data && res.data.description) || 'Something went wrong. Please try again.');
            paint();
            return;
          }

          document.dispatchEvent(new CustomEvent('om:cart:added', { detail: res.data }));

          if (afterAdd === 'checkout') {
            // Keep the button disabled and the picks intact while the browser
            // navigates - repainting here would flash an empty combo panel.
            if (addLabel) addLabel.textContent = 'Taking you to checkout...';
            window.location = base + 'checkout';
            return;
          }

          picks = {};
          lastHit = 0;
          paint();

          if (afterAdd === 'cart_page') {
            window.location = base + 'cart';
            return;
          }

          if (window.OMCart && typeof window.OMCart.refreshAndOpen === 'function') {
            window.OMCart.refreshAndOpen();
          } else {
            window.location = base + 'cart';
          }
        })
        .catch(function () {
          addBtn.classList.remove('loading');
          showError('Could not reach the cart. Please try again.');
          paint();
        });
    }

    addBtn.addEventListener('click', submit);
    if (mobileAdd) mobileAdd.addEventListener('click', submit);

    filter();
    paint();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-hamper]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();